(ns dashboard.views.answer-bank.subs
  (:require [re-frame.core :as rf]
            [dashboard.entity.analysis.db :as analysis.db]))

(rf/reg-sub
 ::answer-bank
 (fn [db]
   (:answer-bank db)))

(rf/reg-sub
 ::data
 :<- [::answer-bank]
 :<- [::analysis.db/answer-id->applied-analyses]
 :<- [::analysis.db/version-id->structured-analysis]
 (fn [[answer-bank answer-id->applied-analyses version-id->structured-analysis] _]
   (let [answer-bank (get answer-bank :data)]
     (map (fn [item]
            (assoc item
                   :applied-analyses (map (fn [{:keys [structured-analysis-version-uuid] :as applied-analysis}]
                                            (assoc applied-analysis
                                                   :structured-analysis
                                                   (get version-id->structured-analysis structured-analysis-version-uuid)))
                                          (get answer-id->applied-analyses (:answer-id item) []))
                   :paginated-list/row-key (:question-id item)))
          answer-bank))))

(rf/reg-sub
 ::loading
 :<- [::answer-bank]
 :<- [::analysis.db/structured-analyses]
 :<- [::analysis.db/applied-analyses]
 (fn [[answer-bank structured-analyses applied-analyses] _]
   (or (get answer-bank :loading)
       (get structured-analyses :loading)
       (get applied-analyses :loading))))
